<template>
  <div
    class="ly_appSize un_phoneView_wrapper hp_posiRel"
    v-if="refGatheringInfo"
  >
    <h1 class="blind">{{ refSeoHeading }}</h1>

    <!-- 모달 (바텀시트) .__show 추가시 오픈 -->
    <article
      v-show="refModalShown"
      class="bl_modal_wrapper __bottomSheet __show"
    >
      <div class="bl_modal_dimed"></div>
      <!-- only Mobile -->
      <div class="bl_modal __onlyMobile">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <img src="/images/oeApp.svg" v-auto-title alt="오이 로고 이미지" />
            <h2>앱에서 더 구경할 수 있어요<br />앱에서 볼까요?</h2>
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <a
            class="el_btn"
            target="_blank"
            :href="storeLink"
            @click="onOpenInAppClick"
            >앱으로 보기</a
          >
          <button class="el_btn __light" @click.stop="refModalShown = false">
            닫기
          </button>
        </section>
      </div>
      <!-- only PC -->
      <div class="bl_modal __onlyPC">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <QRCode :value="storeLink"></QRCode>
            <h2>앱에서 더 구경할 수 있어요</h2>
            <span
              >스마트폰 카메라로 QR코드를 비추면<br />다운로드 페이지로
              연결돼요</span
            >
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <button class="el_btn __light" @click.stop="refModalShown = false">
            닫기
          </button>
        </section>
      </div>
    </article>

    <!-- 플로팅 버튼 -->
    <a
      class="el_floatBtn el_btn"
      :href="storeLink"
      target="_blank"
      @click="onOpenInAppClick"
      >앱으로 보기</a
    >

    <!-- 탑 바 -->
    <header class="bl_topBar">
      <a class="bl_topBar_logo" @click="replaceTo('/')"></a>
    </header>

    <!-- 메인 지면 -->
    <section class="un_gh_header">
      <figure class="un_gh_header_imgWrapper">
        <CustomImage
          :src="refGatheringImage"
          alt="모임 대표 이미지"
        ></CustomImage>
        <!-- <img :src="refGatheringImage" v-auto-title alt="모임 대표 이미지" /> -->
      </figure>
      <div class="un_gh_header_contWrapper">
        <h2 class="un_gh_header_ttl">{{ refGatheringTitle }}</h2>
        <div class="un_gh_header_tag">
          <!-- .--accent 추가시 파란색 -->
          <span
            v-for="(tag, index) in refGatheringTags"
            :key="index"
            :class="tag === '신규 모임' ? '--accent' : ''"
            >#{{ tag }}</span
          >
        </div>
        <div class="un_gh_header_descWrapper">
          <input id="veiwDesc" type="checkbox" />
          <p>
            {{ refGatheringDescription }}
          </p>
          <label for="veiwDesc">자세히 보기</label>
        </div>
        <nav class="un_gh_header_menu">
          <figure
            class="un_gh_header_menu_item"
            v-for="(icon, index) in refIconList"
            :key="index"
            @click="refModalShown = true"
          >
            <CustomImage :src="icon.imgSrc" alt="icon.imgAlt"></CustomImage>
            <!-- <img :src="icon.imgSrc" :v-auto-title alt="icon.imgAlt" /> -->
            <figcaption>{{ icon.text }}</figcaption>
          </figure>
        </nav>
      </div>
    </section>
    <div class="un_gh_cardWrapper">
      <!-- 공지사항 카드 -->
      <section v-if="refGatheringNotice" class="un_gh_card">
        <dl class="un_gh_card_header">
          <dt>공지사항</dt>
          <dd @click="refModalShown = true">모두 보기</dd>
        </dl>
        <figure class="un_gh_card_profile" @click="refModalShown = true">
          <div class="un_gh_card_profile_imgWrapper">
            <img
              class="un_gh_card_profile_mainImg"
              :src="
                refGatheringNotice.author.image || '/images/profile_dummy.svg'
              "
              v-auto-title
              alt="공지사항 작성자 프로필"
            />
            <!-- .__dotCrown .__crown .__star .__star2 로 뱃지 체인지 -->
            <div class="un_gh_card_profile_subImg __crown"></div>
          </div>
          <figcaption>{{ refGatheringNotice.author.nickname }}</figcaption>
        </figure>
        <div class="un_gh_noticeCont" @click="refModalShown = true">
          <h2 class="un_gh_noticeCont_ttl">{{ refGatheringNotice.title }}</h2>
          <p class="un_gh_noticeCont_desc">
            {{ refGatheringNotice.description }}
          </p>
          <section class="un_gh_noticeCont_carousel_wrapper hp_mb16">
            <ul class="un_gh_noticeCont_carousel">
              <li
                v-for="(image, index) in refGatheringNotice.imageList"
                :key="index"
                class="un_gh_noticeCont_carousel_item"
              >
                <img
                  v-if="index === 0"
                  :src="image"
                  v-auto-title
                  alt="공지사항에 업로드 된 이미지"
                />
              </li>
            </ul>
            <div
              class="un_gh_noticeCont_carousel_indicator"
              v-if="false && refGatheringNotice!!.imageList.length > 0"
            >
              <!-- .--focus 추가시 활성화 -->
              <i class="--focus"></i>
              <i class=""></i>
              <i class=""></i>
            </div>
          </section>
          <section class="un_gh_card_ps">
            <div class="un_gh_card_ps_figure_wrapper">
              <figure class="un_gh_card_ps_figure">
                <i class="el_icon_size_24 ic_chat"></i>
                <figcaption>
                  {{ refGatheringNotice.commentInfo.count }}
                </figcaption>
              </figure>
            </div>
            <span class="un_gh_card_ps_txt">{{
              createdAtFormat(refGatheringNotice.createdAt)
            }}</span>
          </section>
        </div>
      </section>
      <!-- 모임일정 카드 -->
      <section class="un_gh_card" v-if="refGatheringScheduleList.length > 0">
        <dl class="un_gh_card_header">
          <dt>모임 일정</dt>
          <dd @click="refModalShown = true">모두 보기</dd>
        </dl>
        <div>
          <ul class="un_schedule_tab">
            <li
              v-for="(schedule, index) in refGatheringScheduleList"
              :class="
                refSelectedSchedule.id === schedule.id
                  ? 'un_schedule_tab_item __focus'
                  : 'un_schedule_tab_item'
              "
              :key="index"
              @click="refSelectedSchedule = schedule"
            >
              <span>{{ schedule.when.getMonth() + 1 }}월</span>
              <p>{{ schedule.when.getDate() }}일</p>
            </li>
          </ul>
          <div class="un_schedule_card">
            <section
              class="un_schedule_card_cont_wrapper"
              @click="refModalShown = true"
            >
              <figure class="un_gh_card_profile">
                <div class="un_gh_card_profile_imgWrapper">
                  <img
                    class="un_gh_card_profile_mainImg"
                    :src="
                      refSelectedSchedule.author.image ||
                      '/images/profile_dummy.svg'
                    "
                    v-auto-title
                    alt="공지사항 작성자 프로필"
                  />
                  <div
                    :class="
                      calcScheduleAuthorBadgeClass(
                        refSelectedSchedule.author.grade
                      )
                    "
                  ></div>
                </div>
                <figcaption>
                  {{ refSelectedSchedule.author.nickname }}
                </figcaption>
              </figure>
              <div class="un_schedule_card_cont_header">
                <dl>
                  <dt>
                    {{ refSelectedSchedule.when.getMonth() + 1 }}월
                    {{ refSelectedSchedule.when.getDate() }}일({{
                      getDayOfWeek(refSelectedSchedule.when)
                    }})
                  </dt>
                  <dd>
                    {{ refSelectedSchedule.closingAt.getMonth() + 1 }}월
                    {{ refSelectedSchedule.closingAt.getDate() }}일({{
                      getDayOfWeek(refSelectedSchedule.closingAt)
                    }}) 신청 마감
                  </dd>
                </dl>
              </div>
              <div class="un_schedule_card_cont_body">
                <dl>
                  <dt>장소</dt>
                  <dd>{{ refSelectedSchedule.place }}</dd>
                </dl>
                <dl>
                  <dt>제목</dt>
                  <dd>
                    {{ refSelectedSchedule.title }}
                  </dd>
                </dl>
                <dl>
                  <dt>참가</dt>
                  <dd class="--profileList">
                    <img
                      v-for="(
                        image, index
                      ) in refSelectedSchedule.memberInfo.memberImageList.slice(
                        0,
                        8
                      )"
                      :key="index"
                      :src="image || '/images/profile_dummy.svg'"
                      v-auto-title
                      alt="참가 유저 프로필"
                    />
                    <!-- 유저 이미지가 줄을 넘어가면 <i> 로 표시 -->
                    <i
                      v-if="
                        refSelectedSchedule.memberInfo.memberImageList.length >
                        8
                      "
                    ></i>
                  </dd>
                  <p>
                    <strong>{{ refSelectedSchedule.memberInfo.count }}</strong
                    >{{
                      refSelectedSchedule.memberInfo.capacity
                        ? `/${refSelectedSchedule.memberInfo.capacity}`
                        : ``
                    }}
                  </p>
                </dl>
              </div>
              <section class="un_gh_card_ps">
                <div class="un_gh_card_ps_figure_wrapper">
                  <figure class="un_gh_card_ps_figure">
                    <!-- .__on 추가시 활성화 -->
                    <i class="el_icon_size_24 ic_chat"></i>
                    <figcaption>
                      {{ refSelectedSchedule.commentInfo.count }}
                    </figcaption>
                  </figure>
                </div>
                <span class="un_gh_card_ps_txt">{{
                  createdAtFormat(refSelectedSchedule.createdAt)
                }}</span>
              </section>
              <section class="un_schedule_card_more">
                <p>자세히 보기</p>
              </section>
            </section>
          </div>
        </div>
      </section>
      <!-- 모임피드 카드 -->
      <section class="un_gh_card" v-if="refGatheringFeedList.length > 0">
        <dl class="un_gh_card_header">
          <dt>모임 피드</dt>
          <dd @click="refModalShown = true">모두 보기</dd>
        </dl>
        <div
          class="un_gh_feedCont_carousel_wrapper"
          v-draggable-scroll
          @scroll="refLastFeedScrollAt = Date.now()"
        >
          <ul class="un_gh_feedCont_carousel">
            <li
              class="un_gh_feedCont_carousel_item"
              v-for="(feed, index) in refGatheringFeedList"
              :key="index"
              @click.stop="
                Date.now() - refLastFeedScrollAt > 20
                  ? (refModalShown = true)
                  : null
              "
            >
              <section class="un_gh_feedCont_carousel_itemInner">
                <!-- 이미지가 없으면 자동으로 작성된 글 생성됨 -->
                <img
                  v-if="feed.imageList.length > 0"
                  :src="
                    typeof feed.imageList[0] === 'string'
                      ? feed.imageList[0]
                      : feed.imageList[0].thumbnailUrl
                  "
                  v-auto-title
                  alt="피드에 업로드 된 이미지"
                />
                <!-- .__blur 추가시 비밀글 / .__video 추가시 재생버튼 -->
                <div
                  :class="[
                    'un_gh_feedCont_carousel_item_contWrapper',
                    feed.isSecret && '__blur',
                    feed.imageList?.length > 0 &&
                      typeof feed.imageList[0] !== 'string' &&
                      '__video',
                  ]"
                >
                  <section class="un_gh_feedCont_carousel_item_cont">
                    <div class="un_gh_feedCont_carousel_item_label">
                      <span v-if="feed.imageList.length > 1"
                        >+{{ feed.imageList.length - 1 }}</span
                      >
                      <span v-if="feed.isSecret">비밀글이에요</span>
                    </div>
                    <div class="un_gh_feedCont_carousel_item_txt">
                      <p>
                        {{ feed.isSecret ? "" : feed.description }}
                      </p>
                    </div>
                  </section>
                  <figure class="un_gh_card_profile">
                    <div class="un_gh_card_profile_imgWrapper">
                      <img
                        class="un_gh_card_profile_mainImg"
                        :src="feed.author.image || '/images/profile_dummy.svg'"
                        v-auto-title
                        alt="피드 작성자 프로필"
                      />
                      <!-- .__dotCrown .__crown .__star .__star2 로 뱃지 체인지 -->
                      <div
                        :class="calcScheduleAuthorBadgeClass(feed.author.grade)"
                      ></div>
                    </div>
                    <figcaption class="hp_cWhite">
                      {{ feed.author.nickname }}
                    </figcaption>
                  </figure>
                </div>
              </section>
              <section class="un_gh_card_ps hp_rowP16">
                <div class="un_gh_card_ps_figure_wrapper">
                  <figure class="un_gh_card_ps_figure">
                    <i class="el_icon_size_24 ic_chat"></i>
                    <figcaption>{{ feed.commentInfo.count }}</figcaption>
                  </figure>
                  <figure class="un_gh_card_ps_figure">
                    <i class="el_icon_size_24 ic_heart"></i>
                    <figcaption>{{ feed.likeInfo.count }}</figcaption>
                  </figure>
                </div>
                <span class="un_gh_card_ps_txt">{{
                  createdAtFormat(feed.createdAt)
                }}</span>
              </section>
            </li>
          </ul>
        </div>
      </section>
      <!-- 멤버 카드 -->
      <section class="un_gh_card" @click="refModalShown = true">
        <dl class="un_gh_card_header">
          <dt class="--number">
            <h2>멤버</h2>
            <p>
              <strong>{{ refGatheringMemberCount }}</strong
              >/{{ refGatheringMemberCapacity }}
            </p>
          </dt>
          <dd>자세히 보기</dd>
        </dl>
        <ul class="un_gh_memberCont">
          <li
            class="un_gh_memberCont_item __dotCrown"
            ref="targetLi"
            v-show="refMemberListByGrade.leaders.length > 0"
          >
            <img
              v-for="(member, index) in omittedElements(
                refMemberListByGrade.leaders,
                refOmittedMemberCount.leaders
              )"
              :key="index"
              :src="member.image || '/images/profile_dummy.svg'"
              v-auto-title
              alt="멤버 프로필"
            />
            <span v-if="refOmittedMemberCount.leaders > 0"
              >+{{ refOmittedMemberCount.leaders }}</span
            >
          </li>
          <li
            class="un_gh_memberCont_item __crown"
            v-show="refMemberListByGrade.staffs.length > 0"
          >
            <img
              v-for="(member, index) in omittedElements(
                refMemberListByGrade.staffs,
                refOmittedMemberCount.staffs
              )"
              :key="index"
              :src="member.image || '/images/profile_dummy.svg'"
              v-auto-title
              alt="멤버 프로필"
            />
            <span v-if="refOmittedMemberCount.staffs > 0"
              >+{{ refOmittedMemberCount.staffs }}</span
            >
          </li>
          <li
            class="un_gh_memberCont_item __star"
            v-show="refMemberListByGrade.fullMembers.length > 0"
          >
            <img
              v-for="(member, index) in omittedElements(
                refMemberListByGrade.fullMembers,
                refOmittedMemberCount.fullMembers
              )"
              :key="index"
              :src="member.image || '/images/profile_dummy.svg'"
              v-auto-title
              alt="멤버 프로필"
            />
            <span v-if="refOmittedMemberCount.fullMembers > 0"
              >+{{ refOmittedMemberCount.fullMembers }}</span
            >
          </li>
          <li
            class="un_gh_memberCont_item __star_gray"
            v-show="refMemberListByGrade.normalMembers.length > 0"
          >
            <img
              v-for="(member, index) in omittedElements(
                refMemberListByGrade.normalMembers,
                refOmittedMemberCount.normalMembers
              )"
              :key="index"
              :src="member.image || '/images/profile_dummy.svg'"
              v-auto-title
              alt="멤버 프로필"
            />
            <span v-if="refOmittedMemberCount.normalMembers > 0"
              >+{{ refOmittedMemberCount.normalMembers }}</span
            >
          </li>
          <li
            class="un_gh_memberCont_item __new"
            v-show="refMemberListByGrade.newMembers.length > 0"
          >
            <img
              v-for="(member, index) in omittedElements(
                refMemberListByGrade.newMembers,
                refOmittedMemberCount.newMembers
              )"
              :key="index"
              :src="member.image || '/images/profile_dummy.svg'"
              v-auto-title
              alt="멤버 프로필"
            />
            <span v-if="refOmittedMemberCount.newMembers > 0"
              >+{{ refOmittedMemberCount.newMembers }}</span
            >
          </li>
        </ul>
      </section>
    </div>

    <!-- 모임 추천 -->
    <article class="ly_appSize __pad0 un_phoneView_wrapper hp_posiRel">
      <section
        class="un_otherGatheringList"
        ref="suggestedGatheringCarouselContainer"
      >
        <div class="un_otherGatheringList_header">
          <h2>이런 모임은 어떠세요?</h2>
          <div class="un_otherGatheringList_btnWRapper">
            <button @click="addSuggestedGatheringCarouselIndex(-1)"></button>
            <button @click="addSuggestedGatheringCarouselIndex(+1)"></button>
          </div>
        </div>
        <!-- 스크롤 일어나는 박스 -->
        <div class="un_otherGatheringList_list">
          <!-- 스크롤 되는 요소 -->
          <div
            class="un_otherGatheringList_list_inner"
            ref="suggestedGatheringCarousel"
          >
            <NuxtLink
              class="un_otherGatheringList_list_item"
              v-for="(
                gathering, index
              ) in refGatheringInfo.suggestGatheringList"
              :key="index"
              :to="`/gathering/${gathering.id}`"
            >
              <CustomImage
                :src="gathering.image"
                alt="모임 이미지"
              ></CustomImage>
              <!-- <img :src="gathering.image" v-auto-title alt="모임 이미지" /> -->
              <section class="un_otherGatheringList_list_desc">
                <h4>#{{ gathering.interest }}</h4>
                <h3>{{ gathering.title }}</h3>
                <span
                  ><strong>{{ gathering.memberInfo.count }}</strong
                  >/{{ gathering.memberInfo.capacity }}명</span
                >
              </section>
            </NuxtLink>
          </div>
        </div>
      </section>
    </article>
  </div>
</template>

<script setup lang="ts">
// 초기 설정
import api from "../../utils/api";
import moment from "moment";
import "moment/dist/locale/ko";
import { useGetStoreLink } from "~/composable/useGetStoreLink";
import { gatheringDetailSchema } from "~/utils/json-ld";
moment.locale("ko");
/////////////////////////////////////////////////////

// 데이터 로딩
const route = useRoute();
const router = useRouter();

const gatheringId = parseInt(route.params["id"]?.toString() || "0");
const _asyncData = await useAsyncData("gatheringInfo", async () => {
  const { result, value } = await api.getGatheringInfo(gatheringId);
  return { result, value };
});
const gatheringInfo = _asyncData.data.value?.value;
////////////////////////////////////////////////////////////////////////

// 방문 로그 찍기

if (import.meta.server) {
  const refer = route.query.refer as string;
  const userId = Number(route.query.userId);
  const segmentId = Number(route.query.segmentId);
  if (refer === "alimtalk") {
    if (userId && segmentId) {
      api.logAlimtalkClicked(userId, segmentId);
    }
  }
}

///////////////////////////////////////////////////////////////////////////

// 데이터 모음
const refGatheringInfo = ref(gatheringInfo);
const refGatheringTitle = ref(gatheringInfo?.title || "");
const refGatheringDescription = ref(gatheringInfo?.description || "");
const refGatheringImage = ref(gatheringInfo?.image || "");
const refGatheringTags = ref(
  gatheringInfo?.tags.concat([
    gatheringInfo.interest,
    gatheringInfo.regionName,
  ]) || []
);
const refGatheringInterest = ref(gatheringInfo?.interest || "");

// SEO 전용 값 (화면 표시에는 쓰지 않는다)
// 검색 이용자는 `서울특별시 종로구` 로 검색하지 않고 `서울`, `종로` 로 검색한다. (SEO 스펙 §2-2)
// 화면에 보이는 refGatheringTags 는 사용자에게 필요한 정보(가입 조건 등)이므로 건드리지 않고,
// 메타 태그가 읽는 배열만 따로 만든다.
const refSeoRegion = ref(splitRegion(gatheringInfo?.regionName));
// 카테고리명은 공급자 언어다. `노래/보컬` 로 검색하는 사람은 없고 `노래교실` 로 검색한다. (스펙 §3)
// 매핑이 없는 카테고리는 원본 카테고리명을 그대로 쓴다.
const refSeoCategory = ref(
  categoryKeywords(gatheringInfo?.interest, {
    regionKeywords: splitRegion(gatheringInfo?.regionName),
    description: gatheringInfo?.description,
  })
);
// gatheringInfo.tags(`4년차 모임`, `62~72년생 모집중`, `인증뱃지 필수` 등)는 전부 문장형이라
// 검색어가 될 수 없다. 화면에는 필요한 정보이므로 refGatheringTags 로 그대로 두고 SEO 에서만 뺀다.
// 모임일정의 장소는 모임마다 전부 다르다. 고유명사가 카테고리어를 압도하므로
// (산악회 2,980 vs 청계산 17,590) 페이지별 검색어 접점을 만드는 가장 큰 레버리지다. (스펙 §4-1)
const refSeoPlaces = ref(
  normalizePlaces((gatheringInfo?.scheduleList || []).map((schedule) => schedule.place))
);
// 카테고리 매핑은 카테고리 경계를 넘는 활동을 잡지 못한다. 사진 모임이 `정모` 도 하고
// `트레킹` 도 가는데 그 말이 소개글에 이미 적혀 있어도 메타에는 반영되지 않았다.
// 사전에 있는 말이 본문에 있는지 확인만 하므로 닉네임·회비·계좌가 새어나갈 수 없다. (스펙 §4-2)
const seoRuleKeywords = [
  ...refSeoCategory.value.keywords,
  ...refSeoRegion.value,
  ...refSeoPlaces.value,
];
const refSeoMatched = ref(
  matchContentKeywords(
    [
      gatheringInfo?.description,
      gatheringInfo?.notice?.description,
      ...(gatheringInfo?.feedList || []).slice(0, 20).map((feed) => feed.description),
    ],
    seoRuleKeywords
  )
);
// 장소명이 카테고리어와 겹칠 수 있다. (예: 일정 장소가 `파크골프장`)
const refSeoTags = ref([
  ...new Set(
    [
      ...seoRuleKeywords,
      ...refSeoMatched.value,
      ...COMMON_SEO_KEYWORDS,
    ].filter(Boolean)
  ),
]);
// 대표어가 없는 카테고리(검색량 미조사)는 원본 카테고리명을 쓰되, `악기/밴드` 처럼
// 슬래시가 든 표기는 `악기` `밴드` 로 나눠 넣는다. 슬래시째로는 검색어가 되지 않는다.
const refSeoCategoryLabels = computed(() =>
  refSeoCategory.value.primary.length > 0
    ? refSeoCategory.value.primary
    : splitInterestLabel(refGatheringInterest.value)
);
const refSeoHeading = computed(() =>
  [
    refGatheringTitle.value,
    ...[...refSeoCategoryLabels.value, ...refSeoRegion.value]
      .filter(Boolean)
      .map((tag) => `#${tag}`),
  ].join(" ")
);
const refMemberList = ref(gatheringInfo?.memberInfo.list || []);
const refGatheringMemberCount = ref(gatheringInfo?.memberInfo.list.length || 0);
const refGatheringMemberCapacity = ref(gatheringInfo?.memberInfo.capacity || 0);
const refGatheringNotice = ref(gatheringInfo?.notice || null);
const refGatheringScheduleList = ref(gatheringInfo?.scheduleList || []);
const refSelectedSchedule = ref(refGatheringScheduleList.value[0] || null);
const refGatheringFeedList = ref(gatheringInfo?.feedList || []);
const refMemberListByGrade = ref({
  leaders: refMemberList.value
    .filter((member) => member.grade === "모임장")
    .sort((a, b) => b.visitAt.getTime() - a.visitAt.getTime()),
  staffs: refMemberList.value
    .filter((member) => !["모임장", "정회원", "일반"].includes(member.grade))
    .sort((a, b) => b.visitAt.getTime() - a.visitAt.getTime()),
  fullMembers: refMemberList.value
    .filter((member) => member.grade === "정회원")
    .sort((a, b) => b.visitAt.getTime() - a.visitAt.getTime()),
  normalMembers: refMemberList.value
    .filter((member) => member.grade === "일반" && !member.isNew)
    .sort((a, b) => b.visitAt.getTime() - a.visitAt.getTime()),
  newMembers: refMemberList.value
    .filter((member) => member.isNew)
    .sort((a, b) => b.visitAt.getTime() - a.visitAt.getTime()),
});

const memberListSpaceWidth = ref({
  leaders: calcMemberListSpaceWidth(refMemberListByGrade.value.leaders),
  staffs: calcMemberListSpaceWidth(refMemberListByGrade.value.staffs),
  fullMembers: calcMemberListSpaceWidth(refMemberListByGrade.value.fullMembers),
  normalMembers: calcMemberListSpaceWidth(
    refMemberListByGrade.value.normalMembers
  ),
  newMembers: calcMemberListSpaceWidth(refMemberListByGrade.value.newMembers),
});
const refOmittedMemberCount = ref({
  leaders: 0,
  staffs: 0,
  fullMembers: 0,
  normalMembers: 0,
  newMembers: 0,
});

const storeLink = computed(() => {
  return useGetStoreLink(deeplink.gatheringHome(gatheringId));
});

// 앱으로 보기 버튼 클릭 (플로팅 버튼 / 모바일 모달)
const onOpenInAppClick = () => {
  marketing.sendNaverConversion("custom002");
};
////////////////////////////////////////////////////////////////////////////////////////////////////////

// UI 모음
const memberListWidth = ref(0);
const targetLi = ref<HTMLElement>();
const refModalShown = ref(false);
const refLastFeedScrollAt = ref(Date.now());
const refIconList = ref([
  {
    imgSrc: "/images/il_calendar_check_green.svg",
    imgAlt: "모임일정 아이콘",
    text: "모임일정",
  },
  { imgSrc: "/images/il_feed.png", imgAlt: "피드 아이콘", text: "피드" },
  {
    imgSrc: "/images/il_notice.png",
    imgAlt: "공지사항 아이콘",
    text: "공지사항",
  },
  { imgSrc: "/images/il_member.png", imgAlt: "멤버 아이콘", text: "멤버" },
]);
////////////////////////////////////////////////////////////////////////////

// 함수 모음
function calcScheduleAuthorBadgeClass(grade: string) {
  let cls = "un_gh_card_profile_subImg";
  if (grade === "모임장") {
    cls += " __dotCrown";
  } else if (grade === "정회원") {
    cls += " __star";
  } else if (grade === "일반") {
    cls += " __star2";
  } else if (grade) {
    cls += " __crown";
  }
  return cls;
}
function createdAtFormat(date: Date) {
  const launching = new Date("2021-09-01");
  const milliSeconds: number = new Date().getTime() - date.getTime();
  const seconds = milliSeconds / 1000;
  if (seconds < 60) {
    return `방금 전`;
  }
  const minutes: number = seconds / 60;
  if (minutes < 60) {
    return `${Math.floor(minutes)}분 전`;
  }
  const hours: number = minutes / 60;
  if (hours < 24) {
    return `${Math.floor(hours)}시간 전`;
  }
  const days: number = hours / 24;
  if (days < 7) {
    return `${Math.floor(days)}일 전`;
  }
  const weeks: number = days / 7;
  if (weeks < 5) {
    return `${Math.floor(weeks)}주 전`;
  }
  const months: number = days / 30;
  if (months < 12) {
    return `${Math.floor(months)}개월 전`;
  }
  const years: number = days / 365;
  return launching < date ? `${Math.round(years)}년 전` : "";
}
function getDayOfWeek(date: Date) {
  return moment(date).format("ddd");
}
function omittedElements(arr: any[], omittedCount: number) {
  return omittedCount > 0 ? arr.slice(0, -omittedCount) : arr;
}
function replaceTo(path: string) {
  useRouter().replace(path);
}
function goTo(path: string) {
  useRouter().push(path);
}
/**
 * @deprecated
 */
function goToApp() {
  const gatheringId = gatheringInfo?.id || 0;
  if (!gatheringId) {
    return;
  }
  // ios 인지 확인하는 if 코드 작성
  gtag("event", "click_앱으로보기");
  if (
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/iOS/i)
  ) {
    const url = `oeapp://action?type=모임&gatheringId=${gatheringId}`;
    window.open(url, "_blank");
    setTimeout(() => {
      window.location.href =
        "https://apps.apple.com/kr/app/오이-4060-취미모임-동호회-동네친구-문화모임/id6480576858";
    }, 2000);
  }
  // macos인지 확인
  else if (navigator.userAgent.match(/Macintosh/i)) {
    const url =
      "https://apps.apple.com/kr/app/오이-4060-취미모임-동호회-동네친구-문화모임/id6480576858";
    window.open(url, "_blank");
  }
  // 안드로이드인지 확인하는 if 코드 작성
  else if (navigator.userAgent.match(/Android/i)) {
    const url = `intent://action?type=모임&gatheringId=${gatheringId}#Intent;scheme=oeapp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.koco.oi_android;end`;
    window.open(url, "_blank");
  } else {
    const url =
      "https://play.google.com/store/apps/details?id=com.koco.oi_android&hl=ko";
    window.open(url, "_blank");
  }
}
function calcMemberListSpaceWidth(arr: any[]): number {
  return arr.reduce((acc, cur, index) => acc + (index === 0 ? 40 : 32), 0);
}
////////////////////////////////////////////////////////////////////////////////////////

const { gtag } = useGtag();

// 훅 모음
if (gatheringInfo) {
  const tags = gatheringInfo.tags;

  const meetingFrequency =
    tags.find((tag) => tag.includes("회 모임")) || undefined; // 숫자만 뽑아내기
  const ranking =
    Number(tags.find((tag) => tag.includes("랭킹"))?.replace(/\D/g, "")) ||
    undefined;
  const upcomingEvents =
    gatheringInfo.scheduleList.length > 0
      ? gatheringInfo.scheduleList.map((schedule) => ({
          date: schedule.when.toISOString(),
          title: schedule.title,
          location: schedule.place,
          currentAttendees: schedule.memberInfo.count,
          maxAttendees: schedule.memberInfo.capacity,
        }))
      : undefined;

  useHead({
    // title 은 meta keywords 보다 검색 가중치가 훨씬 높다. 씬 고유어를 여기 넣는 것이
    // 이 스펙에서 가장 효과 큰 단일 변경이다. (스펙 §2-3)
    title: buildGatheringTitle({
      name: refGatheringTitle.value,
      region: splitRegionParts(gatheringInfo.regionName)?.major ?? "",
      primary: refSeoCategoryLabels.value,
    }),
    link: [
      {
        rel: "canonical",
        href: "https://oe-app.com" + useRoute().path,
      },
    ],
    meta: [
      { property: "og:title", content: refGatheringTitle.value },
      { property: "og:description", content: refGatheringDescription.value },
      { property: "og:image", content: refGatheringImage.value },
      { property: "og:url", content: useRequestURL().host },
      { property: "og:site_name", content: "오이" },
      { property: "og:locale", content: "ko_KR" },
      {
        // 검색결과 스니펫에 그대로 노출되는 값이라 키워드를 앞에 붙이지 않는다.
        // 소개글 정제(첫 80자 · 이모지 제거)는 스펙 §7-2 에서 별도로 다룬다.
        name: "description",
        content: buildDescription(refGatheringDescription.value),
      },
      {
        // 카테고리 · 지역 · 공통 태그가 refSeoTags 에 모두 들어있다.
        name: "keywords",
        content: refSeoTags.value.join(","),
      },
    ],
    script: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            gatheringDetailSchema({
              id: gatheringInfo.id,
              name: gatheringInfo.title,
              description: gatheringInfo.description,
              image: gatheringInfo.image,
              category: gatheringInfo.interest,
              location: {
                // addressRegion/addressLocality 는 `서울특별시` 보다 `서울` 이 표준 표기다.
                // 지역 데이터에 없는 값이면 기존처럼 원본을 그대로 쓴다.
                region:
                  splitRegionParts(gatheringInfo.regionName)?.major ??
                  gatheringInfo.regionName.split(" ")[0],
                district:
                  splitRegionParts(gatheringInfo.regionName)?.minor ??
                  gatheringInfo.regionName.split(" ")[1],
              },
              memberCount: gatheringInfo.memberInfo.list.length,
              maxMembers: gatheringInfo.memberInfo.capacity,
              establishedYear: gatheringInfo.createdAt.toISOString(),
              meetingFrequency,
              ranking,
              upcomingEvents,
            }),
          ],
        }),
      },
    ],
  });
  watch(memberListWidth, (width) => {
    // 1. 맴버 프로필이 <li>의 너비를 넘어가면, 마지막 프로필은 생략되고 <span>을 추가한다.
    // 2. span의 수는 생략된 멤버 프로필의 수
    refOmittedMemberCount.value.leaders =
      memberListSpaceWidth.value.leaders > width
        ? 1 + Math.ceil((memberListSpaceWidth.value.leaders - width) / 32)
        : 0;
    refOmittedMemberCount.value.staffs =
      memberListSpaceWidth.value.staffs > width
        ? 1 + Math.ceil((memberListSpaceWidth.value.staffs - width) / 32)
        : 0;
    refOmittedMemberCount.value.fullMembers =
      memberListSpaceWidth.value.fullMembers > width
        ? 1 + Math.ceil((memberListSpaceWidth.value.fullMembers - width) / 32)
        : 0;
    refOmittedMemberCount.value.normalMembers =
      memberListSpaceWidth.value.normalMembers > width
        ? 1 + Math.ceil((memberListSpaceWidth.value.normalMembers - width) / 32)
        : 0;
    refOmittedMemberCount.value.newMembers =
      memberListSpaceWidth.value.newMembers > width
        ? 1 + Math.ceil((memberListSpaceWidth.value.newMembers - width) / 32)
        : 0;
  });
  const onResize = () => {
    if (targetLi.value) {
      const rect = targetLi.value.getBoundingClientRect();
      memberListWidth.value = rect.width;
    }
  };
  onMounted(() => {
    onResize();
    setTimeout(() => {
      onResize();
    }, 800);
    window.addEventListener("resize", onResize);
  });
  onUnmounted(() => {
    window.removeEventListener("resize", onResize);
  });
} else {
  router.replace("/gathering/notfound");
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////

const suggestedGatheringCarouselIndex = ref(0);
const suggestedGatheringCarousel = ref<HTMLDivElement>();
const suggestedGatheringCarouselContainer = ref<HTMLDivElement>();
const addSuggestedGatheringCarouselIndex = (value: number) => {
  const suggestGatheringList = gatheringInfo!!.suggestGatheringList;
  suggestedGatheringCarouselIndex.value = Math.max(
    0,
    Math.min(
      suggestedGatheringCarouselIndex.value + value,
      suggestGatheringList.length - 2
    )
  );

  const boxWidth =
    suggestedGatheringCarouselContainer.value!.getBoundingClientRect().width;
  const width = 218;
  let x = -(suggestedGatheringCarouselIndex.value * (width + 16));
  const itemTotalLength =
    suggestGatheringList.length * 218 + (suggestGatheringList.length - 1) * 16;
  const emptySpace = itemTotalLength - boxWidth;
  x = Math.max(x, -emptySpace - 48);

  if (suggestedGatheringCarousel.value) {
    suggestedGatheringCarousel.value.style.transition =
      "transform 0.4s ease-in-out";
    suggestedGatheringCarousel.value.style.transform = `translateX(${x}px)`;
  }
};
</script>

<style scoped>
@import "@/assets/css/seo.css";
</style>
